<template>
  <q-card class="license-state-dialog-container center relative scroll">
    <div
      class="row items-center icon-container"
      style="padding: unset"
    >
      <img
        :src="licenseState === licenseStatesMap.ExpiredOffline ? License_x_icon : License_Locked_icon"
        alt="license-icon"
      />
    </div>
    <div>
      <div class="dialog-title text-center">
        {{ licenseState === licenseStatesMap.ExpiredOffline ? $t('generic.licenseStates.licenseExpired.title') : $t('generic.licenseStates.licenseLocked.title') }}
      </div>
      <div class="dialog-description gordita-400-16-r text-center">
        <div
          v-if="licenseState === licenseStatesMap.ExpiredOffline"
          class="gordita-400-16-r"
        >
          Your current license is expired and needs to be renewed and reloaded. Contact your Customer Success Manager and refer to this
          <a
            href="https://docs.incredibuild.com/win/latest/windows/offline_licenses.htm?Highlight=offline"
            class="link-font text-brand_almost_black"
          >
            article</a
          >
        </div>

        <div
          v-if="licenseState === licenseStatesMap.Locked"
          class="gordita-400-16-r"
        >
          {{ $t('generic.licenseStates.licenseLocked.description') }}
        </div>
      </div>
    </div>

    <div
      v-if="licenseState === licenseStatesMap.Locked"
      :data-testid="elementsId.dialogs.licenseDialogs.licenseLockedExpiredOfflineDialog.refreshNowButton"
      class="dialog-footer text-center"
    >
      <span class="gordita-regular-14 footer-text">{{ $t('generic.licenseStates.licenseLocked.footerText') }}</span>
      <span
        :class="{ animate: refreshLicenseSpinner }"
        class="gordita-500-14-m refresh-btn focus-be-gone"
        @click.prevent.stop="refreshLicense(false, license?.key)"
      >
        <span style="padding-right: 4px">{{ $t('generic.licenseStates.refreshNow') }}</span>
        <q-icon
          size="16"
          name="icon-uil uil-sync"
          class="spinner-icon"
        />
      </span>
    </div>
  </q-card>
</template>

<script>
import elementsId from '@/const/elementIds.json';
import { useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import { defineComponent, inject } from 'vue';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import License_x_icon from '../../../../assets/images/LicenseStatesDialogs/license-error-icon.svg';
import License_Locked_icon from '../../../../assets/images/LicenseStatesDialogs/license-locked-icon.svg';
import { licenseDialogMixins } from './licenseDialogMixins';

export default defineComponent({
  // This Dialog for license: Locked - Expired Offline
  name: 'LicenseLockedExpiredOfflineDialog',
  mixins: [licenseDialogMixins],
  props: {
    licenseState: {
      type: String,
      default: 'Expired',
    },
  },
  setup() {
    const coordinatorsService = inject(IKCoordinatorsService);

    const GQL_useLicenseInfoQuery = useCommonDataQuery(() => ({ coordinatorId: coordinatorsService.selectedCoordinator.value || '' }));
    return { GQL_useLicenseInfoQuery, elementsId };
  },
  data() {
    return {
      License_x_icon,
      License_Locked_icon,
    };
  },
  computed: {
    license() {
      return this.GQL_useLicenseInfoQuery?.result?.value?.ibManagerEntities?.license;
    },
  },
});
</script>

<style scoped lang="scss">
@import 'LicenseDialogsCommonStyle';
</style>
